export default class sortArray{

    /**
    * // ✎NOTE 1 : ---------〖排序〗---------
    * @param {Array} _array : 要排序的陣列
    * @param {String} _key : 陣列裡用來當排序參數的鍵值
    * @param {String} _key_type : 排序參數 : "str", "ch_char", "int", "other"
    */
    static desc(_array = [], _key, _key_type){
        if(_key_type==="ch_char"){
            _array.sort((a, b)=>{
                return a.data[_key][0].codePointAt() - b.data[_key][0].codePointAt()
            })
        }
        if(_key_type==="int"){
            _array.sort((a, b)=>{
                return a.data[_key] - b.data[_key]
            })
        }
    }
    static desc_pad(_array = [], _key, _key_type){
        if(_key_type==="ch_char"){
            _array.sort((a, b)=>{
                if(a.data[_key]===null || a.data[_key]===undefined){
                    if(b.data[_key]===null || b.data[_key]===undefined){ return 1 }
                    return -1
                }
                if(b.data[_key]===null || b.data[_key]===undefined){ return 1 }
                return (a.data[_key] > b.data[_key])? 1 : -1
            })
        }
        if(_key_type==="int"){
            _array.sort((a, b)=>{
                return a.data[_key] - b.data[_key]
            })
        }
    }
    static asc(_array = [], _key, _key_type){
        if(_key_type==="ch_char"){
            _array.sort((a, b)=>{
                return b.data[_key][0].codePointAt() - a.data[_key][0].codePointAt()
            })
        }
        if(_key_type==="int"){
            _array.sort((a, b)=>{
                return b.data[_key] - a.data[_key]
            })
        }
    }
    static desc_through_key(_array = []){ _array.sort((a, b)=> a.key - b.key) }
    static asc_through_key(_array = []){ _array.sort((a, b)=> b.key - a.key) }

    static null_first(_array = [], _key){
        _array.sort((a, b)=>{
            if(b.data[_key]===null || b.data[_key]===""){
                if(a.data[_key]===null || a.data[_key]===""){ return 1}
                return -1
            }
            else if(a.data[_key]===null || a.data[_key]===""){return 1}
            else {return 1}
        })
    }
    static null_last(_array = [], _key){
        _array.sort((a, b)=>{
            if(a.data[_key]===null || a.data[_key]===""){
                if(b.data[_key]===null || b.data[_key]===""){ return 1}
                return -1
            }
            else if(b.data[_key]===null || b.data[_key]===""){return 1}
            else {return 1}
        })
    }
}